<template>
  <div>
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-row>
        <a-col :span="12"> 基本信息 </a-col>
      </a-row>
      <a-form-model
        layout=""
        :model="data"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        labelAlign="left"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row>
          <a-col :span="11">
            <a-form-model-item label="订单编号">
              <a-input v-model="data.orderNo" placeholder=""> </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2">
            <a-form-model-item label="支付单号">
              <a-input v-model="data.user" placeholder=""> </a-input>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row>
          <a-col :span="11">
            <a-form-model-item label="用户uid">
              <a-input v-model="data.userUid" placeholder=""> </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2">
            <a-form-model-item label="用户手机号码">
              <a-input v-model="data.userPhone" placeholder=""> </a-input>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row>
          <a-col :span="11">
            <a-form-model-item label="订单总价">
              <a-input v-model="data.user" placeholder=""> </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2">
            <a-form-model-item label="所属门店">
              <a-input v-model="data.shopName" placeholder=""> </a-input>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row>
          <a-col :span="11">
            <a-form-model-item label="拼团状态">
              <a-input v-model="data.statusUserStr" placeholder=""> </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2">
            <a-form-model-item label="下单时间">
              <a-input v-model="data.createTime" placeholder=""> </a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>

    <!-- 第三方支付信息 -->
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-row>
        <a-col :span="12"> 第三方支付信息 </a-col>
      </a-row>
      <a-form-model
        layout=""
        :model="data"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        labelAlign="left"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row>
          <a-col :span="11">
            <a-form-model-item label="支付信息">
              <a-input v-model="data.payTypeStr" placeholder=""> </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2">
            <a-form-model-item label="第三方交易号">
              <a-input v-model="data.thirdOrderNo" placeholder=""> </a-input>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row>
          <a-col :span="11">
            <a-form-model-item label="第三方交易状态">
              <a-input v-model="data.thirdOrderStatus" placeholder="">
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2">
            <a-form-model-item label="第三方通知时间">
              <a-input v-model="data.thirdNotifyTime" placeholder=""> </a-input>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row>
          <a-col :span="11">
            <a-form-model-item label="第三方查询状态">
              <a-input v-model="data.thirdQueryStatus" placeholder="">
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2">
            <a-form-model-item label="第三方查询金额">
              <a-input v-model="data.thirdQueryMoney" placeholder=""> </a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
    <!-- 费用信息
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-row>
        <a-col :span="12"> 费用信息 </a-col>
      </a-row>
      <a-form-model
        layout=""
        :model="data"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        labelAlign="left"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row>
          <a-col :span="11">
            <a-form-model-item label="商品总价">
              <a-input v-model="data.priceGoods" placeholder=""> </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2">
            <a-form-model-item label="优惠金额">
              <a-input v-model="data.priceOffer" placeholder=""> </a-input>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row>
          <a-col :span="11">
            <a-form-model-item label="秒杀折扣">
              <a-input v-model="data.user" placeholder=""> </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2">
            <a-form-model-item label="门店承担">
              <a-input v-model="data.couponMerchantsBear" placeholder=""> </a-input>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row>
          <a-col :span="11">
            <a-form-model-item label="支付金额">
              <a-input v-model="data.pricePay" placeholder=""> </a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div> -->
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-row>
        <a-col :span="12"> 商品信息 </a-col>
      </a-row>
      <a-table
        :columns="columns"
        :row-key="(record) => record.goodsId"
        :data-source="goods"
      >
        <template slot="pic2" slot-scope="text">
          <img class="img2" :src="text" alt="" />
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
import { storeOrderDetails } from "@/api/storeApi.js";

const columns = [
  {
    title: "商品id",
    dataIndex: "goodsId",
    align: "center",

    // scopedSlots: { customRender: "name" },
  },
  {
    title: "商品名称",
    dataIndex: "goodsName",
    align: "center",

    // filters: [
    //   { text: "Male", value: "male" },
    //   { text: "Female", value: "female" },
    // ],
    // width: "10%",
  },
  {
    title: "商品图片",
    dataIndex: "goodsImg",
    // width: "15%",
    align: "center",
    scopedSlots: { customRender: "pic2" },
  },
  {
    title: "价格",
    dataIndex: "goodsSpecPayPrice",
    align: "center",
    // sorter: true,
    // width: "10%",
    // scopedSlots: { customRender: "avatar" },
  },

  {
    title: "商品数量",
    dataIndex: "priceDiscount",
    align: "center",
    // sorter: true,
    // width: "10%",
    // scopedSlots: { customRender: "name" },
  },
];
export default {
  components: {},
  data() {
    return {
      data: [],
      goods: [],
      orderNo: "",
      columns,
      labelCol: { span: 6 },
      wrapperCol: { span: 17, offset: 1 },
      textarealabelCol: { span: 2 },
      textareaWrapperCol: { span: 21, offset: 1 },
      formInline: {
        user: "",
        password: "",
      },
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        // pageSizeOptions: ["10", "20", "40", "80", "100"],
        // showTotal: (total) => `共 ${total} 条`,
        // pageSize: 10,
      },
    };
  },
  mounted() {
    this.orderNo = this.$route.query.orderNo;
    console.log("this.orderNo", this.orderNo);
    this.getDetailed();
  },
  methods: {
    handleSubmit(e) {
      console.log(this.formInline);
    },
    onChange(date, dateString) {
      console.log(date, dateString);
    },
    // 获取订单明细
    getDetailed() {
      storeOrderDetails(this.orderNo).then((res) => {
        this.data = res.data;
        this.goods = res.data.goods;
        console.log(res);
        console.log("this.goods", this.goods);
      });
    },
  },
};
</script>

<style lang="scss" scoped="" type="text/css">
.illustrate {
  color: red;
}
.img2 {
  width: 100px;
  height: 50px;
}
</style>


// WEBPACK FOOTER //
// src/views/orderManagement/seckillOrderTwo/seckillOrderDetailsTwo.vue